import type { ComponentStyle } from "@yamada-ui/core"

export const Em: ComponentStyle<"Em"> = {
  baseStyle: {
    fontStyle: "italic",
  },
}
